import { escapeRegex } from '@epihub/core/src/fn/regex';
import type { Procedure } from './procedure';

export function createPathname(
  def: Pick<Procedure, 'path' | 'params'>,
  params: Record<string, any>,
) {
  return Object.entries(params).reduce((acc, [name, value]) => {
    return acc.replace(new RegExp(escapeRegex(`/:${name}`), 'g'), `/${value}`);
  }, def.path);
}
